import { makeAutoObservable, runInAction } from 'mobx';

import { history } from '../';
import agent from '../api/agent';
import { User, UserForLogin } from '../models/User';
import { store } from './Store';

export default class UserStore {
  user?: User = undefined;

  constructor() {
    makeAutoObservable(this);
  }

  get isLoggedIn() {
    // console.log('isLoggedIn', !!this.user);
    return !!this.user;
  }

  get isDarshi() {
    return this.isLoggedIn && this.user!.email?.toLowerCase() === 'darshaniw2016@gmail.com';
  }

  login = async (creds: UserForLogin) => {
    try {
      const user = await agent.Account.login(creds);
      store.commonStore.setToken(user.token);
      runInAction(() => {
        this.user = user;
      });
      history.push('/');
      store.modalStore.closeModal();
    } catch (error: any) {
      throw error;
    }
  };

  logout = () => {
    store.commonStore.setToken(null);
    this.user = undefined;
    history.push('/');
  };

  getUser = async () => {
    try {
      const user = await agent.Account.current();
      runInAction(() => (this.user = user));
    } catch (error: any) {
      console.log(error);
    }
  };
}
